import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const { count, setIsOpen } = useCart();
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[#0B0F17]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <img src="/logo.png" alt="DetroitEmoto" className="h-10 w-auto" data-testid="logo-image" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="desktop-nav">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="font-mono text-sm uppercase tracking-widest text-slate-300 transition-colors hover:text-volt"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          {user && (
            <Link
              to="/admin"
              className="font-mono text-sm uppercase tracking-widest text-volt transition-colors hover:text-white"
              data-testid="nav-admin"
            >
              Admin
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setIsOpen(true)}
            className="relative rounded-sm border border-white/10 p-2 text-slate-300 transition-colors hover:border-volt hover:text-volt"
            data-testid="cart-button"
          >
            <ShoppingCart className="h-5 w-5" />
            {count > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-volt text-xs font-bold text-obsidian" data-testid="cart-count">
                {count}
              </span>
            )}
          </button>
          {user ? (
            <button
              onClick={logout}
              className="hidden items-center gap-2 rounded-sm border border-white/10 px-3 py-2 text-sm text-slate-300 transition-colors hover:border-volt hover:text-volt md:flex"
              data-testid="logout-button"
            >
              <User className="h-4 w-4" />
              Logout
            </button>
          ) : (
            <Link
              to="/admin"
              className="hidden items-center gap-2 rounded-sm border border-white/10 px-3 py-2 text-sm text-slate-300 transition-colors hover:border-volt hover:text-volt md:flex"
              data-testid="admin-login-link"
            >
              <User className="h-4 w-4" />
              Login
            </Link>
          )}
          <button
            className="rounded-sm border border-white/10 p-2 text-slate-300 md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-white/10 bg-[#0B0F17] px-4 py-4 md:hidden" data-testid="mobile-nav">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="block py-3 font-mono text-sm uppercase tracking-widest text-slate-300"
              onClick={() => setMobileOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/admin" className="block py-3 font-mono text-sm uppercase tracking-widest text-volt" onClick={() => setMobileOpen(false)} data-testid="mobile-nav-admin">
                Admin
              </Link>
              <button onClick={() => { logout(); setMobileOpen(false); }} className="block py-3 font-mono text-sm uppercase tracking-widest text-slate-300" data-testid="mobile-logout">
                Logout
              </button>
            </>
          ) : (
            <Link to="/admin" className="block py-3 font-mono text-sm uppercase tracking-widest text-slate-300" onClick={() => setMobileOpen(false)} data-testid="mobile-admin-login">
              Login
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
